import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

import * as styles from './index.css';

export interface IHTML5BannerProps {
  context: IAdFoxBannerContext;
}

export class HTML5Banner extends React.PureComponent<IHTML5BannerProps, {}> {
  public render() {
    return (
      <div className={styles['container']}>
        <iframe
          width="100%"
          marginWidth={0}
          marginHeight={0}
          scrolling="no"
          frameBorder="0"
          srcDoc={this.props.context.html}
        />
      </div>
    );
  }
}
